import useCallApi from '../../utilities/axios'
import * as umServinceURL from '../um/umServiceURL'
import {
    DeleteExternalProjectResult,
    GetListAllResultType,
    InputAdd,
    NewExternalProjectResult,
    UpdateExternalProjectResult,
} from './searchFormExternalProjectType'

interface KeywordSearch {
    keywordSearch?: string | null
    pageNo: number
    pageSize: number
}

const useManageExternalProject = () => {
    const callApi = useCallApi()

    const getData = async (props: KeywordSearch) => {
        const { keywordSearch = null, pageNo = 1, pageSize = 10 } = props
        const { data } = await callApi.axiosPost<GetListAllResultType>({
            url: umServinceURL.getExternalProject,
            params: { keyword: keywordSearch, pageNo: pageNo, pageSize: pageSize },
        })
        return data.result
    }

    const postNewProject = async (props: InputAdd) => {
        const result = await callApi.axiosPost<NewExternalProjectResult>({
            url: umServinceURL.postExternalProject,
            params: { ...props },
        })
        return { result }
    }

    const editProject = async (props: InputAdd) => {
        const result = await callApi.axiosPost<UpdateExternalProjectResult>({
            url: umServinceURL.postExternalProject,
            params: { ...props },
        })
        return { result }
    }

    const deleteProject = async (props: number) => {
        const result = await callApi.axiosDelete<DeleteExternalProjectResult>({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/project/deleteProjectOutsource?projectID=${props}`,
        })
        return { result }
    }

    return { getData, postNewProject, editProject, deleteProject }
}

export default useManageExternalProject
